import { render, staticRenderFns } from "./SubjectTypeList.vue?vue&type=template&id=39c1590a&scoped=true&"
import script from "./SubjectTypeList.vue?vue&type=script&lang=js&"
export * from "./SubjectTypeList.vue?vue&type=script&lang=js&"
import style0 from "./SubjectTypeList.vue?vue&type=style&index=0&id=39c1590a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1590a",
  null
  
)

export default component.exports